<script setup lang="ts">
import { ref, onMounted, type Ref } from 'vue'
import { useRoute } from 'vue-router'
import { Icon } from '@iconify/vue'

import { type ReturnedBatch, } from '@/types/batch-types'
import { getReturnedBatchById } from '@/api/batches'
import EditFinishedForm from '@/components/features/batches/forms/EditFinishedForm.vue'
import GeneratePackingListDialog from '@/components/features/batches/components/GeneratePackingListDialog.vue'
import BatchActions from "@/components/features/batches/components/BatchActions.vue";

const route = useRoute()
const batchId = route.params.id as string

const batch: Ref<any | null> = ref(null)
const loading = ref(true)
const error = ref<string | null>(null)
const showGeneratePackingListDialog = ref(false)

const fetchBatch = async () => {
  loading.value = true
  error.value = null
  try {
    const response: ReturnedBatch = await getReturnedBatchById(batchId)
    batch.value = response
  } catch (err) {
    error.value = 'Failed to fetch batch data. Please try again.'
  } finally {
    loading.value = false
  }
}

const formDisabled = ref(true)

const closeClosedPackingListDialog = () => {
  showGeneratePackingListDialog.value = false;
};

onMounted(async () => {
  fetchBatch()
})
</script>

<template>
  <div v-if="loading">Loading batch data...</div>

  <div v-else-if="error" class="text-red-500">{{ error }}</div>

  <div v-else class="p-10 bg-white rounded-xl">
    <div class="flex justify-between items-center mb-3">
      <RouterLink to="/batches" class="flex items-center gap-x-2 group hover:text-primary-default">
        <Icon
          icon="material-symbols:arrow-back-rounded"
          class="text-3xl group-hover:translate-x-2 transition-transform"
        />
        <span>Back</span>
      </RouterLink>

      <h1 class="font-semibold text-2xl capitalize flex-1 text-center">Finished Batch</h1>
    </div>

    <BatchActions
        :batch-id="batchId"
        :is-returned-batch="true"
        :returned-batch-data="batch"
        :previous-batch-data="batch"
    />
    <EditFinishedForm v-model="batch"  :disabled="formDisabled" type="view"/>
  </div>


  <GeneratePackingListDialog
    :showGeneratePackingListDialog="showGeneratePackingListDialog"
    :batchNumber="batch?.batchNumber"
    :batchId= "batchId"
    :rolls="batch?.rolls"
    :close="closeClosedPackingListDialog"
    :finishingSupplierId="batch?.finishingSupplierId"
  />
</template>
